<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    :type="to ? undefined : 'button'"
    class="flex h-9 w-9 flex-none items-center justify-center rounded-full text-primary-100 hover:bg-primary-400 hover:text-white hover:no-underline"
    :title="label"
    :aria-label="label"
  >
    <i class="far fa-lg" :class="icon"></i>
  </component>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { RouteLocationRaw } from 'vue-router';

defineProps({
  icon: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  to: {
    type: Object as PropType<RouteLocationRaw | null>,
    default: null,
  },
});
</script>
